import { useCustomerEventJsonRecordDataUpdate } from "gen/endpoints/customer-event/customer-event";
import { CustomerEventCreateDataAPIData } from "gen/model/customerEventCreateDataAPIData";
import { CustomerEventCreateDataAPIDataRequest } from "gen/model/customerEventCreateDataAPIDataRequest";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormDrawer } from "shared/components/form/FormDrawer";
import { FormTextArea } from "shared/components/input/text/TextArea";

export interface EventCreateDataEditDrawerProps {
  customerEventId: string;
  customerEventCreateData: CustomerEventCreateDataAPIData;
  onCloseComplete: () => void;
}

export const EventCreateDataEditDrawer: React.FC<
  EventCreateDataEditDrawerProps
> = ({ customerEventId, customerEventCreateData, onCloseComplete }) => {
  const { t } = useTranslation(["events"]);

  const form = useForm<CustomerEventCreateDataAPIDataRequest>({
    defaultValues: customerEventCreateData,
  });

  const { mutateAsync: updateCustomerEventJsonRecordData } =
    useCustomerEventJsonRecordDataUpdate();

  const formProps = {
    form,
    onSubmit: (data: CustomerEventCreateDataAPIDataRequest) =>
      updateCustomerEventJsonRecordData({ customerEventId, data }),
  };
  return (
    <FormDrawer
      title={t("events:createData")}
      formProps={formProps}
      bodyProps={{
        "data-private": true,
      }}
      onCloseComplete={onCloseComplete}
    >
      <FormTextArea name="data_json" title={t("events:createData")} />
    </FormDrawer>
  );
};
